


export const FETCH_MYPROFILES_INIT_ACTION = "FETCH_MYPROFILES_INIT_ACTION";
export const FETCH_MYPROFILES_SUCCESS_ACTION =
FETCH_MYPROFILES_INIT_ACTION + "_SUCCESS";
export const FETCH_MYPROFILES_FAIL_ACTION =
FETCH_MYPROFILES_INIT_ACTION + "_ERROR";


